import Vue from 'vue'
import { sharedFilters, uniqueFilters } from '../constants'

const setFilters = (filters, eventView, newFilters) => {
  if (filters[eventView]) {
    Object.entries(newFilters).forEach(([filter, value]) => {
      if (sharedFilters.includes(filter)) {
        Vue.set(filters, filter, value)
      } else if (uniqueFilters.includes(filter)) {
        Vue.set(filters[eventView], filter, value)
      }
    })
  }
}

export default {
  setEventViewFilters: (s, { eventView, filters }) => {
    setFilters(s.filters, eventView, filters)
  },

  setLocationFilters: (s, { houses }) => {
    Vue.set(s.filters, 'houses', houses)
  }
}
